
import { Carousel } from "bootstrap";
import GLightbox from "glightbox/src/js/glightbox";

import "../Scss/style.scss";
import "glightbox/dist/css/glightbox.css";

document.addEventListener('DOMContentLoaded', () => {

    GLightbox({
        touchNavigation: true,
        loop: true
    });

    let logoSize;
    let fontSize;
    let st;
    let currentScrollPos = 0;
    let overlay;

    function isOverlayTotallyScrolled() {
        return overlay.scrollHeight - overlay.scrollTop <= overlay.clientHeight;
    }

    function disableRubberBand(event, _clientY) {
        let clientY = event.targetTouches[0].clientY - _clientY;

        if (overlay.scrollTop === 0 && clientY > 0) {
            event.preventDefault();
        }

        if (isOverlayTotallyScrolled() && clientY < 0) {
            event.preventDefault();
        }
    }

    function scrollFix() {
        let _clientY = null;

        overlay.addEventListener('touchstart', (event) => {
            if (event.targetTouches.length === 1) {
                _clientY = event.targetTouches[0].clientY;
            }
        });

        overlay.addEventListener('touchmove', (event) => {
            if (event.targetTouches.length === 1) {
                disableRubberBand(event, _clientY);
            }
        });
    }

    function resizeLogo() {
        let newLogoSize = logoSize - (st * 0.3);
        const logo = document.querySelector('.navbar a.navbar-brand > img');

        if (newLogoSize >= 50) {
            logo.style.maxHeight = `${newLogoSize}px`;
        } else if (st !== undefined && st !== 0) {
            logo.style.maxHeight = '50px';
        }
    }

    function getNavbarHeight() {
        return document.querySelector('nav.navbar.fixed-top').offsetHeight;
    }

    function initialize() {
        overlay = document.querySelector('nav.navbar-mobile');
        st = window.scrollY || document.documentElement.scrollTop;
        fontSize = parseInt(getComputedStyle(document.documentElement).fontSize);
        logoSize = parseInt(getComputedStyle(document.querySelector('.navbar a.navbar-brand > img')).maxHeight);

        const highlightBild = document.querySelectorAll('img.highlight-image');
        const imageWrap = document.querySelectorAll('div.highlight-image-wrap');

        highlightBild.forEach(img => {
            img.addEventListener('load', function() {
                const url = this.currentSrc;
                this.parentElement.nextElementSibling.style.backgroundImage = `url(${url})`;
                this.parentElement.nextElementSibling.style.display = 'block';
            });

            const parentDiv = img.closest('div');
            if (getComputedStyle(parentDiv).backgroundImage === 'none') {
                const url = img.currentSrc || img.getAttribute('src');
                img.parentElement.nextElementSibling.style.backgroundImage = `url(${url})`;
                img.parentElement.nextElementSibling.style.display = 'block';
            }
        });

        window.addEventListener('scroll', () => {
            st = window.scrollY || document.documentElement.scrollTop;
            const newPosition = 50 - (st * 0.1);
            const newPositionText = 10 + (st * 0.1);

            document.querySelectorAll('.highlight-image-wrap').forEach(el => {
                el.style.backgroundPosition = `center ${newPosition}%`;
            });
            document.querySelectorAll('.highlight-text').forEach(el => {
                el.style.bottom = `${newPositionText}%`;
            });

            resizeLogo();
        });

        document.querySelector('.navbar-brand').addEventListener('click', (e) => {
            if (st > 100) {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        });

        document.querySelector('div.navbar-mobile-toggle').addEventListener('click', () => {
            const navbarMobile = document.querySelector('nav.navbar-mobile');
            const slideSpeed = 500;

            if (navbarMobile.style.display === 'none' || !navbarMobile.style.display) {
                currentScrollPos = window.scrollY;
                const scrollSpeed = 2000 * (st / document.body.scrollHeight);

                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    document.documentElement.style.position = 'fixed';
                    document.body.style.position = 'fixed';
                    navbarMobile.style.top = `${getNavbarHeight()}px`;
                    navbarMobile.style.display = 'block';
                    document.querySelector('main').style.display = 'none';
                    document.querySelector('footer').style.display = 'none';
                }, scrollSpeed);
            } else {
                document.querySelector('main').style.display = '';
                document.querySelector('footer').style.display = '';
                setTimeout(() => {
                    document.documentElement.style.position = '';
                    document.body.style.position = '';
                    navbarMobile.style.display = 'none';
                    window.scrollTo({ top: currentScrollPos, behavior: 'smooth' });
                }, 100);
            }
        });
    }

    initialize();
    resizeLogo();
    scrollFix();

    document.querySelectorAll('div.projekt a').forEach(link => {
        link.addEventListener('click', (e) => {
            const hrefParts = link.getAttribute('href').split('#');
            if (hrefParts.length === 2) {
                e.preventDefault();
                const element = document.getElementById(hrefParts[1]);
                const offset = window.innerHeight / 5;
                window.scrollTo({
                    top: element.getBoundingClientRect().top + window.scrollY - offset,
                    behavior: 'smooth'
                });
            }
        });
    });
});